var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "excerpt" }, [
    _c("p", { key: "text", domProps: { innerHTML: _vm._s(_vm.text) } }),
    _vm._v(" "),
    _vm.item.length > 150
      ? _c(
          "span",
          {
            key: "btn",
            staticClass: "show-btn",
            on: {
              click: function($event) {
                _vm.showAll = !_vm.showAll
              }
            }
          },
          [
            !_vm.showAll
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-plus-square fa-w-14",
                    attrs: {
                      "aria-hidden": "true",
                      focusable: "false",
                      "data-prefix": "far",
                      "data-icon": "plus-square",
                      role: "img",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 448 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "currentColor",
                        d:
                          "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showAll
              ? _c(
                  "svg",
                  {
                    staticClass: "svg-inline--fa fa-minus-square fa-w-14",
                    attrs: {
                      "aria-hidden": "true",
                      focusable: "false",
                      "data-prefix": "far",
                      "data-icon": "minus-square",
                      role: "img",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 448 512"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        fill: "currentColor",
                        d:
                          "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
                      }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v("\n\t\t" + _vm._s(_vm.btn_label))
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }